// =============================================================================
// Route Management – shared types
// Matches GET /api/perfect-truck/routes/all response schema
// =============================================================================

export interface Route {
  id: number;
  locationId: string;
  locationName: string;
  sapId: string | null;
  routeNumber: string;
  routeType: string | null;
  displayOrder: number;
  locationType: string;
  organizationType: string;
  is3pl: boolean;
  isActive: boolean;
  createdAt: string;
  createdBy: string;
  updatedAt: string | null;
  updatedBy: string | null;
}

export interface RouteListResponse {
  data: Route[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  isFirst: boolean;
  isLast: boolean;
}

export interface RouteStats {
  totalRoutes: number;
  locationCount: number;
  activeRoutes: number;
}

export interface RouteManagementScreenProps {
  onBack: () => void;
  onViewLocationDetail?: (locationName: string) => void;
}

export const ROUTE_TYPE_OPTIONS = [
  { label: 'LG Delivery', value: 'LG Delivery' },
  { label: 'SM Delivery', value: 'SM Delivery' },
  { label: 'Bulk',        value: 'Bulk'        },
  { label: 'Night',       value: 'Night'       },
  { label: 'Express',     value: 'Express'     },
];
